var customPopover = function ($ = jQuery) {
  $('[data-toggle="popover"]').popover();

  $('[data-toggle="popover"]').on('click', function () {
    $('[data-toggle="popover"]').parent().find('.popover.fade').attr('tabindex', '0');
    $('[data-toggle="popover"]').parent().find('.popover.fade').focus();
  });

  $('body').on('click', function (e) {
    $('[data-toggle="popover"]').each(function () {
      // the 'is' for buttons that trigger popups
      // the 'has' for icons within a button that triggers a popup

      if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
        $(this).popover('hide');
      }
    });
  });

  $('body').on('hidden.bs.popover', function (e) {
    $(e.target).data('bs.popover').inState = { click: false, hover: false, focus: false };
  });

  // Initiate the active panel's popover in the middle(vertically) of the page when scolling
  var tabPanel = (jQuery('.tablist-container .tab-content').offset() || { top: NaN }).top - (jQuery(window).height() / 4);
  var tabPanelHeight = jQuery('.nav-tablist').height();
  var isStuck = false;
  $(window).scroll(function () {
    if (!isStuck) {
      if (jQuery(this).scrollTop() > tabPanel && jQuery(this).scrollTop() < tabPanel + (tabPanelHeight / 2.5)) {
        if ($('.tab-pane.active .popover-dot').length !== 0) {
          $('.tab-pane.active .popover-dot')[0].click();
        }
        isStuck = true;
      }
    }
  });

  $('.nav-tablist li div').on('click', function () {
    setTimeout(function () {
      if ($('.tab-pane.active .popover-dot').length !== 0) {
        $('.tab-pane.active .popover-dot')[0].click();
      }
    }, 500);
  });

  $('.nav-tablist li div').off('click').on('click', function () {
    const $clickedTab = $(this).find('span');
    $('.nav-tablist li div span').each(function () {
      const $ele = $(this);
      if ($ele.hasClass('active') && $ele.attr('id') !== $clickedTab.attr('id')) {
        $ele.removeClass('active');
        $ele.parent().removeClass('active');
      }
    });
    if (!$clickedTab.hasClass('active')) {
      $clickedTab.addClass('active');
      $clickedTab.parent().addClass('active');
    } else {
      $clickedTab.removeClass('active');
      $clickedTab.parent().removeClass('active');
    }
  });

  $('[data-toggle="popover"],.nav-tablist li div').on('keypress', function (event) {
    const isEnterPressed = event.key === 'Enter' || event.keyCode === 13;
    if (isEnterPressed) {
      $(this).trigger('click');
    }
  });
};

export { customPopover };
